import React from 'react';
import {Trans} from '@lingui/react';
import VisuallyHidden from '@reach/visually-hidden';

import iconify from '../iconify';

const ContinueIcon = ({customColor, ...props}) => (
  <>
    <VisuallyHidden>
      <Trans id="icon.continue">
        Icona che rappresenta prova iniziata ma non finita
      </Trans>
    </VisuallyHidden>
    <svg width="1em" height="1em" viewBox="0 0 124.17 31.04" {...props}>
      <circle
        fill={customColor ? customColor : 'currentColor'}
        cx="15.52"
        cy="15.52"
        r="15.52"
      />
      <circle
        fill={customColor ? customColor : 'currentColor'}
        cx="62.08"
        cy="15.52"
        r="15.52"
      />
      <circle
        fill={customColor ? customColor : 'currentColor'}
        cx="108.64"
        cy="15.52"
        r="15.52"
      />
    </svg>
  </>
);

export default iconify(ContinueIcon);
